import { jsx, jsxs } from 'react/jsx-runtime';
import { Flex } from '@fabric-app/ui/components/Flex';
import { H1, P } from '@fabric-app/ui/components/Typography';
import { Button } from '@fabric-app/ui/components/Button';
import { Modal } from '@fabric-app/ui/components/Modal/Modal';
import { topUpModal } from '../../stores/modalTopUpStore.js';
import { IconBigIcon48Warn } from '@fabric-app/icons/svg';
import { styled } from 'styled-components';
import { cssVar } from '@fabric-app/ui/theme/variables';

const UpgradePromptModalContent_CreditsTopUp = ({ onClose }) => {
  return /* @__PURE__ */ jsx(Modal.Content, {
    width: "xs+",
    children: /* @__PURE__ */ jsxs(Modal.Body, {
      padding: "sm",
      children: [
        /* @__PURE__ */ jsx(Flex, {
          direction: "column",
          justifyContent: "flex-end",
          gap: "sections",
          style: {
            position: "absolute",
            width: "100%",
            top: `calc(16px + env(safe-area-inset-top))`,
            right: 16
          },
          children: /* @__PURE__ */ jsx(Modal.Close, {})
        }),
        /* @__PURE__ */ jsxs(Flex, {
          direction: "column",
          gap: "sectionsMedium",
          alignItems: "center",
          style: {
            paddingTop: "calc(2rem + env(safe-area-inset-top))",
            width: "100%"
          },
          children: [
            /* @__PURE__ */ jsx(IconBigIcon48Warn, {}),
            /* @__PURE__ */ jsxs(Flex, {
              direction: "column",
              gap: "sectionsShort",
              alignItems: "center",
              style: {
                textAlign: "center",
                maxWidth: "340px"
              },
              children: [
                /* @__PURE__ */ jsx(Modal.Title, {
                  as: H1,
                  style: {
                    fontWeight: 600,
                    fontSize: 24,
                    lineHeight: 1,
                    letterSpacing: "-0.02em"
                  },
                  children: "You're out of thinking credits!"
                }),
                /* @__PURE__ */ jsx(Modal.Description, {
                  size: "sm",
                  as: P,
                  color: "tertiary",
                  children: "Top up your credits to utilize AI and processing features."
                })
              ]
            }),
            topUpModal.isAvailable() ? /* @__PURE__ */ jsx(Button, {
              shape: "full",
              variant: "bg-primary-reverse",
              onClick: () => {
                onClose();
                topUpModal.open();
              },
              children: "Top up now"
            }) : /* @__PURE__ */ jsx(CannotBuyBanner, {
              children: "You can only buy more credits on desktop or web"
            })
          ]
        })
      ]
    })
  });
};
const CannotBuyBanner = styled.div.withConfig({
  displayName: "UpgradePromptModalContent_CreditsTopUp__CannotBuyBanner",
  componentId: "sc-7ff2c986-0"
})([
  `background-color:`,
  `;padding:0.75rem;text-align:center;color:`,
  `;font-size:0.875rem;width:100%;border-radius:0.5rem;`
], cssVar["color-bg-section-primary"], cssVar["color-text-tertiary"]);

export { UpgradePromptModalContent_CreditsTopUp };
//# sourceMappingURL=UpgradePromptModalContent_CreditsTopUp.js.map
